export const admin = [
    {
        _name: 'CSidebarNav',
        _children: [
            {
                _name: 'CSidebarNavTitle',
                _children: ['Raftel']
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Dashboard',
                to: '/dashboard',
                icon: 'cil-speedometer'
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Employees',
                to: '/employeeDetail',
                icon: 'cil-speedometer'
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Reimbursements',
                to: '/reimbursement',
                icon: 'cil-speedometer'
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Documents',
                to: '/test',
                icon: 'cil-speedometer'
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Help',
                to: '/addEmployees',
                icon: 'cil-speedometer'
            }
        ]
    }
];
